import {
  TEXT_SIZE_MENU_ID,
  TextSizeMenu,
  ToolbarAnchor,
} from '@components/ArtBoard/ArtboardToolbar'
import { getCanvasState } from '@components/ArtBoard/Canvas/helpers/canvas'
import type { ID, TextSize } from '@octopus-do/octopus-project-core'
import { Toolbar } from '@octopus-do/octopus-storybook'
import { Clone, Trash } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { createSwitch } from '@/utils'
import { ColorMenu } from './components'
import { NOTE_BORDER_WIDTH } from './constants'
import { useStickyNoteActions } from './hooks'

interface Props {
  id: ID
  color: string
  textSize: TextSize
}

export const StickyNotesItemActionsToolbar: React.FC<Props> = ({
  id,
  color,
  textSize,
}) => {
  const { scale } = getCanvasState(
    document.getElementById('gestureMovableContainer')
  )

  const { onChangeColor, onChangeTextSize, onDuplicate, onDelete } =
    useStickyNoteActions(id)

  const switcher = createSwitch()
    .case(['color'], onChangeColor)
    // the menu reports TEXT_SIZE_OPTIONS ids, which are TextSize values
    .case([TEXT_SIZE_MENU_ID], (size) => onChangeTextSize(size as TextSize))
    .case(['duplicate'], onDuplicate)
    .case(['delete'], onDelete)

  const onClick = (keys: string[]) => switcher.run(keys)

  return (
    <ToolbarAnchor borderWidth={NOTE_BORDER_WIDTH} scale={scale}>
      <Toolbar.Root onClick={onClick}>
        <ColorMenu color={color} />
        <TextSizeMenu textSize={textSize} />
        <Toolbar.Divider />
        <Toolbar.Button icon={Clone} id="duplicate" tooltip="Duplicate" />
        <Toolbar.Button
          icon={Trash}
          id="delete"
          tooltip="Delete"
          variant="danger"
        />
      </Toolbar.Root>
    </ToolbarAnchor>
  )
}
